import { useConfiguration } from "./WithConfiguration";

export const HeaderLogo: React.FC = () => {
  const configuration = useConfiguration();
  if (!configuration?.logo) {
    return null;
  }
  return <img className="h-7" src={configuration.logo} />;
};
